import classNames from 'classnames'
import PropTypes from 'prop-types'
import css from '../global-nav.scss'

const ToggleNav = ({ onClick }) => (
  <button
    className={classNames(css.navToggle, 'hidden-md', 'visible-xs')}
    type="button"
    onClick={onClick}
  >
    <span className="sr-only">Toggle navigation</span>
    <span className={css.iconBar} />
    <span className={css.iconBar} />
    <span className={css.iconBar} />
  </button>
)

ToggleNav.propTypes = {
  onClick: PropTypes.func,
}

export default ToggleNav
